import React from "react";
import { useObserver } from "mobx-react";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { ProfessionSelectorDialog } from "@components/ProfessionSelectorDialog";
import { Professions } from "@bonliva-crm/shared";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { TeacherExpertise } from "../components/Teacher/TeacherExpertise";
import { SSKExpertise } from "../components/SSK/SSKExpertise";
import { SocionomExpertise } from "../components/Socionom/SocionomExpertise";
import { ResponsiblePersonSelect } from "../components/ResponsiblePersonSelect";
import { DoctorExpertise } from "../components/Doctor/DoctorExpertise";
import { OnlyExperienceExpertise } from "../components/OnlyExperience/OnlyExperienceExpertise";
import { PsykologExpertise } from "../components/OnlyExperience/PsykologExpertise";
import { RadiographersExpertise } from "../components/Radiographers/RadiographersExpertise";
import { ProfessionToggleButton } from "../components/Common/ProfessionToggleButton";
import { OnlyExperienceStore } from "../components/OnlyExperience/OnlyExperienceStore";
import { DoctorStore } from "../components/Doctor/DoctorStore";
import { TeacherStore } from "../components/Teacher/TeacherStore";
import { SSKStore } from "../components/SSK/SSKStore";
import { RadiographersStore } from "../components/Radiographers/RadiographersStore";
import { SocionomStore } from "../components/Socionom/SocionomStore";
import { createProfessionStore } from "../components/expertise-profession-store-factory";

export function ConsultantExpertiseInfo() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();
  const professionSelectionStore = editorStore.professionSelectionStore;
  const classes = useStyles({});

  const renderProfession = () => {
    const p = professionSelectionStore.currentProfession;

    const profStore = editorStore.getProfessionStore(p);

    if (!profStore) {
      return null;
    }

    switch (p) {
      case Professions.SE_ARBETSTERAPEUT:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_AUDIONOM:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_BARNMORSKA:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_BIOMEDICINSK_ANALYTIKER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_DIETIST:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_FARMACEUTER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_FYSIOTERAPEUT:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_HALSO_OCH_SJUKVARDKURATOR:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_INTERNREKRYTERING:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_LAKARE:
        return (
          <DoctorExpertise
            key={p}
            profession={Professions.SE_LAKARE}
            store={profStore as DoctorStore}
          />
        );

      case Professions.SE_LARARE:
        return <TeacherExpertise key={p} store={profStore as TeacherStore} />;

      case Professions.SE_MEDICINSKA_SEKRETERARE:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_PSYKOLOG:
        return <PsykologExpertise key={p} store={profStore as OnlyExperienceStore} />;

      case Professions.SE_PSYKOTERAPEUT:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.SE_RONTGENSJUKSKOTERSKA:
        return (
          <RadiographersExpertise
            key={p}
            profession={p}
            store={profStore as RadiographersStore}
          />
        );

      case Professions.SE_SOCIONOM:
        return (
          <SocionomExpertise key={p} profession={p} store={profStore as SocionomStore} />
        );

      case Professions.SE_SSK:
        return <SSKExpertise key={p} store={profStore as SSKStore} />;

      case Professions.SE_USK:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.NO_LEGE:
        return (
          <DoctorExpertise
            key={p}
            profession={Professions.NO_LEGE}
            store={profStore as DoctorStore}
          />
        );

      case Professions.NO_SYKEPLEIE:
        return <SSKExpertise store={profStore as SSKStore} />;

      case Professions.DK_JORDEMODER:
        return (
          <OnlyExperienceExpertise
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_LAEGER:
        return (
          <DoctorExpertise
            key={p}
            profession={Professions.DK_LAEGER}
            store={profStore as DoctorStore}
          />
        );

      case Professions.DK_RADIOGRAFER:
        return (
          <RadiographersExpertise
            key={p}
            profession={p}
            store={profStore as RadiographersStore}
          />
        );

      case Professions.DK_SOCIAL_OG_SUNDHEDSASSISTENT:
        return (
          <RadiographersExpertise
            key={p}
            profession={p}
            store={profStore as RadiographersStore}
          />
        );

      case Professions.DK_SYGEPLEJERSKER:
        return <SSKExpertise key={p} store={profStore as SSKStore} />;

      case Professions.DK_SOCIALPAEDAGOG:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_HJAELPEPLEJER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_FAMILJEBEHANDLARE:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_SOCIAL_OG_SUNDHEDSHJAELPER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_PLEJER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_SYGEHJAELPER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_OMSORGSMEDARBEJDER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_PSYKIATRIMEDARBEJDER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_TERAPEUT:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_PAEDAGOGISK_ASSISTENT:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_SOCIALRAADGIVER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_ERGOTERAPEUT:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.DK_PAEDAGOGMEDHJAELPER:
        return (
          <OnlyExperienceExpertise
            key={p}
            profession={p}
            store={profStore as OnlyExperienceStore}
          />
        );

      case Professions.FI_LAAKARI:
        return (
          <DoctorExpertise
            key={p}
            profession={Professions.FI_LAAKARI}
            store={profStore as DoctorStore}
          />
        );

      case Professions.FI_SAIRAANHOITAJA:
        return <SSKExpertise key={p} store={profStore as SSKStore} />;

      default:
        return null;
    }
  };

  return useObserver(() => (
    <div className={classes.root}>
      <ProfessionSelectorDialog
        open={professionSelectionStore.showProfessionSelector}
        professions={professionSelectionStore.professions}
        onClose={() => professionSelectionStore.professionSelectionClose()}
        onSelect={(prof) => {
          const nextIndex = editorStore.form.values.professions.length;
          const profStore = createProfessionStore(prof, nextIndex, editorStore);

          if (profStore) {
            editorStore.addProfessionStore(prof, profStore);
            professionSelectionStore.professionSelect(prof);
          }
        }}
      />

      <ResponsiblePersonSelect />

      <ProfessionToggleButton
        error={editorStore.form.getError("expertise.profession")}
        options={editorStore.form.values.professions.map((x) => x.professionName)}
        value={professionSelectionStore.currentProfession}
        onChange={(value) => professionSelectionStore.setCurrentProfession(value)}
        onNew={() => professionSelectionStore.setShowProfessionSelector(true)}
      />

      {renderProfession()}
    </div>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    ...theme.mixins.childrenMarginBottom(8),
    flex: 1,
    margin: 8,
    paddingBottom: 15 // because of -15px bottom padding in FormTabs
  },

  toggleButtonGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderRadius: 4,
    boxShadow: theme.shadows[2]
  },

  toggleButton: {
    width: "100%"
  },

  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(2)
  }
}));
